import { pushLeadEvent, getSurveySettings } from './leadActivity';
import { FeedbackSurveyModal, FeedbackSummary } from './LeadFeedback';
import { useState } from 'react';

const STATUS_COLORS = {
  confirmed:  { bg: '#E3F2FD', color: '#1565c0', label: '✅ Confirmed' },
  completed:  { bg: '#E8F5E9', color: '#2e7d32', label: '🏆 Completed' },
  cancelled:  { bg: '#FFEBEE', color: '#c62828', label: '❌ Cancelled' },
  postponed:  { bg: '#FFF8E1', color: '#e65100', label: '⏰ Postponed' },
  pending:    { bg: '#F3E5F5', color: '#6a1b9a', label: '🕐 Pending' },
};

const MOCK_APPOINTMENTS = [];

const inp = { width: '100%', padding: '8px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', outline: 'none', marginBottom: 10 };

export function LeadAppointments({ leads = [] }) {
  const [appointments, setAppointments] = useState(MOCK_APPOINTMENTS);
  const [showAdd, setShowAdd] = useState(false);
  const [filter, setFilter] = useState('all');
  const [form, setForm] = useState({ lead_name: '', phone: '', product: '', date: '', time: '', notes: '', status: 'pending' });
  const [toast, setToast] = useState('');

  const flash = (msg) => { setToast(msg); setTimeout(() => setToast(''), 2200); };
  const [surveyFor, setSurveyFor] = useState(null);
  const sendSurvey = (id) => {
    setAppointments(prev => prev.map(a => a.id === id ? { ...a, survey_sent: true } : a));
    const ap = appointments.find(a => a.id === id);
    if (ap) pushLeadEvent({ phone: ap.phone, name: ap.lead_name, type: 'survey', text: 'Feedback survey sent on WhatsApp (preview mode)' });
    flash('📋 Feedback survey sent (preview mode)');
  };
  const saveFeedback = (id, rating, comment) => {
    setAppointments(prev => prev.map(a => a.id === id ? { ...a, feedback: { rating, comment } } : a));
    const ap = appointments.find(a => a.id === id);
    if (ap) pushLeadEvent({ phone: ap.phone, name: ap.lead_name, type: 'feedback', text: 'Feedback received: ' + rating + '/5' + (comment ? ' - "' + comment + '"' : '') });
    flash('⭐ Feedback received');
  };

  const filtered = appointments.filter(a => filter === 'all' || a.status === filter);

  const addAppointment = () => {
    if (!form.lead_name || !form.date) { flash('❌ Name and date required'); return; }
    setAppointments([...appointments, { ...form, id: Date.now() }]);
    setForm({ lead_name: '', phone: '', product: '', date: '', time: '', notes: '', status: 'pending' });
    setShowAdd(false);
    pushLeadEvent({ phone: form.phone, name: form.lead_name, type: 'appointment', text: 'Appointment booked for ' + form.date + (form.time ? ' ' + form.time : '') + (form.product ? ' (' + form.product + ')' : '') });
    flash('✅ Appointment added (preview mode)');
  };

  const updateStatus = (id, status) => {
    setAppointments(appointments.map(a => a.id === id ? { ...a, status } : a));
    const ap0 = appointments.find(a => a.id === id);
    if (ap0) pushLeadEvent({ phone: ap0.phone, name: ap0.lead_name, type: 'status', text: 'Appointment marked ' + status });
    flash('✅ Status updated');
    if (status === 'completed') {
      const ap = appointments.find(a => a.id === id);
      if (ap) {
        if (getSurveySettings().autoSend) sendSurvey(id);
        else setSurveyFor({ ...ap, status });
      }
    }
  };

  const today = new Date().toDateString();
  const upcoming = appointments.filter(a => a.status === 'confirmed' && new Date(a.date) >= new Date()).length;
  const todayCount = appointments.filter(a => new Date(a.date).toDateString() === today).length;

  return (
    <div style={{ padding: 20 }}>
      {surveyFor && <FeedbackSurveyModal appointment={appointments.find(a => a.id === surveyFor.id) || surveyFor} onSend={sendSurvey} onResponse={saveFeedback} onClose={() => setSurveyFor(null)} />}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <div style={{ fontSize: 19, fontWeight: 800, color: '#1a1a2e', letterSpacing: '-0.01em' }}>📅 Appointments</div>
          <div style={{ fontSize: 12.5, color: '#8a8a8a', marginTop: 5 }}>{upcoming} upcoming · {todayCount} today</div>
        </div>
        <button onClick={() => setShowAdd(true)} style={{ padding: '9px 18px', background: '#25d366', color: '#fff', border: 'none', borderRadius: 24, fontSize: 12.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', boxShadow: '0 2px 6px rgba(37,211,102,0.3)' }}>
          + New Appointment
        </button>
      </div>

      <FeedbackSummary appointments={appointments} />

      {/* Summary */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 8, marginBottom: 16 }}>
        {Object.entries(STATUS_COLORS).map(([k, v]) => (
          <div key={k} onClick={() => setFilter(filter === k ? 'all' : k)}
            style={{ background: filter === k ? v.bg : '#fff', border: `1.5px solid ${filter === k ? v.color : '#f0f0f0'}`, borderRadius: 12, padding: '12px 14px', cursor: 'pointer', textAlign: 'center', transition: 'all .15s', boxShadow: filter === k ? `0 2px 8px ${v.color}22` : '0 1px 3px rgba(0,0,0,0.05)' }}>
            <div style={{ fontSize: 18, fontWeight: 800, color: v.color }}>{appointments.filter(a => a.status === k).length}</div>
            <div style={{ fontSize: 10, color: '#aaa', marginTop: 2 }}>{k}</div>
          </div>
        ))}
      </div>

      {/* List */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {filtered.length === 0 && (
          <div style={{ textAlign: 'center', color: '#aaa', fontSize: 13, padding: '48px 20px' }}>📭 No appointments found</div>
        )}
        {filtered.map(a => {
          const sc = STATUS_COLORS[a.status] || STATUS_COLORS.pending;
          const isToday = new Date(a.date).toDateString() === today;
          return (
            <div key={a.id} style={{ background: '#fff', borderRadius: 14, border: `1px solid ${isToday ? '#25d36640' : '#eef0f2'}`, padding: '16px 18px', boxShadow: isToday ? '0 2px 10px #25d36622' : '0 1px 3px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 8 }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 800, color: '#1a1a2e' }}>{a.lead_name}</div>
                  <div style={{ fontSize: 11, color: '#aaa', marginTop: 2 }}>📱 {a.phone} {a.product && `· 📦 ${a.product}`}</div>
                  <div style={{ fontSize: 12, color: '#555', marginTop: 4 }}>
                    📅 {a.date} {a.time && `⏰ ${a.time}`}
                    {isToday && <span style={{ marginLeft: 8, background: '#e8f5e9', color: '#2e7d32', padding: '1px 8px', borderRadius: 10, fontSize: 10, fontWeight: 700 }}>TODAY</span>}
                  </div>
                  {a.notes && <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>💬 {a.notes}</div>}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8 }}>
                  <span style={{ background: sc.bg, color: sc.color, padding: '4px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700 }}>{sc.label}</span>
                  <select value={a.status} onChange={e => updateStatus(a.id, e.target.value)}
                    style={{ fontSize: 11, padding: '4px 8px', border: '1px solid #eee', borderRadius: 6, fontFamily: 'inherit', cursor: 'pointer', outline: 'none' }}>
                    {Object.entries(STATUS_COLORS).map(([k, v]) => (
                      <option key={k} value={k}>{v.label}</option>
                    ))}
                  </select>
                </div>
              </div>
              {a.status === 'confirmed' && (
                <div style={{ marginTop: 10, display: 'flex', gap: 8 }}>
                  <button onClick={() => window.open(`https://wa.me/${(a.phone||'').replace(/\D/g,'')}?text=${encodeURIComponent(`Hi ${a.lead_name}, your appointment is confirmed for ${a.date}${a.time ? ' at ' + a.time : ''}. We look forward to meeting you!`)}`, '_blank')}
                    style={{ flex: 1, padding: '7px 0', background: '#25d366', color: '#fff', border: 'none', borderRadius: 8, fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>
                    💬 Send Confirmation
                  </button>
                  <button onClick={() => updateStatus(a.id, 'completed')}
                    style={{ flex: 1, padding: '7px 0', background: '#E8F5E9', color: '#2e7d32', border: 'none', borderRadius: 8, fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>
                    ✅ Mark Complete
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Add modal */}
      {showAdd && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1400, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setShowAdd(false)}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 24, width: 420, maxWidth: '92vw', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 12px 40px rgba(0,0,0,0.2)' }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 16 }}>📅 New Appointment</div>
            <label style={{ fontSize: 11, fontWeight: 700, color: '#555' }}>Customer Name *</label>
            <input style={{ ...inp, marginTop: 6 }} placeholder="Name" value={form.lead_name} onChange={e => setForm({ ...form, lead_name: e.target.value })} />
            <label style={{ fontSize: 11, fontWeight: 700, color: '#555' }}>Phone</label>
            <input style={{ ...inp, marginTop: 6 }} placeholder="91XXXXXXXXXX" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
            <label style={{ fontSize: 11, fontWeight: 700, color: '#555' }}>Product</label>
            <input style={{ ...inp, marginTop: 6 }} placeholder="Product / Service" value={form.product} onChange={e => setForm({ ...form, product: e.target.value })} />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div>
                <label style={{ fontSize: 11, fontWeight: 700, color: '#555' }}>Date *</label>
                <input type="date" style={{ ...inp, marginTop: 6 }} value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} />
              </div>
              <div>
                <label style={{ fontSize: 11, fontWeight: 700, color: '#555' }}>Time</label>
                <input type="time" style={{ ...inp, marginTop: 6 }} value={form.time} onChange={e => setForm({ ...form, time: e.target.value })} />
              </div>
            </div>
            <label style={{ fontSize: 11, fontWeight: 700, color: '#555' }}>Notes</label>
            <textarea style={{ ...inp, marginTop: 6, minHeight: 60 }} placeholder="Any notes..." value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} />
            <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
              <button onClick={() => setShowAdd(false)} style={{ flex: 1, padding: '10px 0', background: '#f0f0f0', color: '#333', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
              <button onClick={addAppointment} style={{ flex: 2, padding: '10px 0', background: '#25d366', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>Save Appointment</button>
            </div>
          </div>
        </div>
      )}

      {toast && (
        <div style={{ position: 'fixed', bottom: 24, right: 24, background: '#1a1a2e', color: '#fff', padding: '12px 20px', borderRadius: 8, fontSize: 13, fontWeight: 600, zIndex: 2000 }}>{toast}</div>
      )}
    </div>
  );
}
